import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VueTelInput from 'vue-tel-input'
import vuetify from './plugins/vuetify'
import VueFirestore from 'vue-firestore'
import VueSimpleAlert from "vue-simple-alert"
import vueHeadful from 'vue-headful'

// Plugin setup
Vue.use(VueFirestore)
Vue.component('vue-headful', vueHeadful)
Vue.use(VueTelInput)
Vue.use(VueSimpleAlert)
Vue.config.productionTip = false

// Firebase config
// const firebaseConfig = {
//   apiKey: "AIzaSyAFdsZt407nV1JV7luqKeZioqyYOaqoQV8",
//   authDomain: "bilstein-app.firebaseapp.com",
//   databaseURL: "https://bilstein-app.firebaseio.com",
//   projectId: "bilstein-app",
//   storageBucket: "bilstein-app.appspot.com",
//   messagingSenderId: "123411604807",
//   appId: "1:123411604807:web:b6e5465108ca05ffe71862",
//   measurementId: "G-V5C9FV772C"
// }
const firebaseConfig = {
  apiKey: "AIzaSyDlULJ5FMMJ65JgcAIdbAs-QuG-1kBUSvg",
  authDomain: "bilsteinclub.firebaseapp.com",
  projectId: "bilsteinclub",
  storageBucket: "bilsteinclub.firebasestorage.app",
  messagingSenderId: "163782000539",
  appId: "1:163782000539:web:7139ff4a5c9893379e6b3e"
};

const fb = firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()

firebase.analytics()

export { fb, db }

let app
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      firebase,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})